exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root{--dark:var(--theme_color_dark);--accent:var(--theme_color_accent);--ocean:var(--theme_color_light);--button-border:var(--theme_border_color)}._8MAq9{padding:0 0 144px!important;padding:0 0 9rem!important}._2Dq-6{height:400px;width:100%}._3b9xH{display:inline-block}._3et7g{padding-top:64px;padding-top:4rem;padding-left:128px;padding-left:8rem;width:100%;background-color:#fff}._3tMdW{background-image:url(\"http://image.flaticon.com/icons/svg/252/252025.svg\")}", ""]);

// exports
exports.locals = {
	"noPadding": "_8MAq9",
	"mapWrapper": "_2Dq-6",
	"editTestimonialView": "_3b9xH",
	"wrapper": "_3et7g",
	"markerImage": "_3tMdW"
};